import { registerLiteCustomElement } from 'maverick.js/element';
import { I as Icon } from './icons/component.js';
import 'maverick.js/dom';
import 'maverick.js';
import 'media-icons';

registerLiteCustomElement(Icon);

export { Icon };
